export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes5f_sell.246b76aa.mp3";